export type { FormInstance, FormProps, FormItemProps } from 'antd'
// export { Form } from 'antd'

import { Form as AntdForm } from 'antd'

import { FormItem } from './FormItem'

export const Form = Object.assign(AntdForm, {
  ...AntdForm,
  Item: FormItem
})
